export default __webpack_public_path__ + "static/about_growth-64859293409765293177a531023bbc67.jpg";